import { render, staticRenderFns } from "./flightSegments.vue?vue&type=template&id=187744ba&scoped=true&"
import script from "./flightSegments.vue?vue&type=script&lang=ts&"
export * from "./flightSegments.vue?vue&type=script&lang=ts&"
import style1 from "./flightSegments.vue?vue&type=style&index=1&id=187744ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187744ba",
  null
  
)

export default component.exports